import { render, staticRenderFns } from "./FooterBar.vue?vue&type=template&id=bf64a860&"
import script from "./FooterBar.vue?vue&type=script&lang=js&"
export * from "./FooterBar.vue?vue&type=script&lang=js&"
import style0 from "./FooterBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports